export enum StatusEnum {
  Active = 'Active',
  InActive = 'Inactive',
  Deleted = 'Deleted',
}

export const StatusTranslationKey: Record<StatusEnum, string> = {
  [StatusEnum.Active]: 'common.active',
  [StatusEnum.InActive]: 'common.inactive',
  [StatusEnum.Deleted]: 'common.deleted',
};
